export default __webpack_public_path__ + "static/media/chef.3810488b.png";